import { getCookieConsentValue } from 'react-cookie-consent';

export const AnalyticsEvents = {
  AccountCreated: 'sb_account_created',
  BookingComplete: 'sb_booking_complete',
  ConsentGranted: 'sb_consent_granted',
};

export function hasCookieConsent() {
  return getCookieConsentValue() === 'true';
}

export function pushDataLayerEvent(event, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

/**
 * Pushes the booking complete event at most once per booking per browser
 * session, so refreshing the success screen doesn't double count.
 */
export function trackBookingComplete(bookingId) {
  if (!bookingId) {
    return;
  }

  const storageKey = `sb_booking_tracked_${bookingId}`;
  try {
    if (window.sessionStorage.getItem(storageKey)) {
      return;
    }
    window.sessionStorage.setItem(storageKey, 'true');
  } catch {
    // Storage can be unavailable (private mode, blocked site data); tracking should still happen.
  }

  pushDataLayerEvent(AnalyticsEvents.BookingComplete, {
    booking_id: bookingId,
  });
}
